import React, { FC } from 'react';
import {
  easyRefundAdvantage,
  easyRefundAdvantagesContainer,
  easyRefundAdvantageText,
  refundInfoText,
} from './styles';
import { Typography } from 'fronton-react';
import {
  ArrowBendDoubleUpLeftIcon,
  CheckSquareOffsetIcon,
  LemanaProLogoSimpleIcon,
} from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';

export const STORE_BRAND_NAME = 'Лемана\u00A0ПРО';
export const DATA_QA_STORE_RETURN_TEXT = 'store-return-text';
export const DATA_QA_PRODUCT_RETURN_MODAL_CONTENT = 'product-return-modal-content';

type Props = {
  hidden?: boolean;
};

export const ProductReturnsModalContent: FC<Props> = ({ hidden }) => {
  const { t } = useTranslation();

  return (
    <div hidden={hidden} data-qa={DATA_QA_PRODUCT_RETURN_MODAL_CONTENT}>
      <div className={refundInfoText}>
        <Typography variant="m" size="body_long" color="text-primary" data-qa={DATA_QA_STORE_RETURN_TEXT}>
          {t('product-returns.modal.part1', { brand: STORE_BRAND_NAME })}
        </Typography>
        <Typography variant="m" size="body_long" color="text-primary">
          {t('product-returns.modal.part2')}
        </Typography>
      </div>
      <div className={easyRefundAdvantagesContainer}>
        <div className={easyRefundAdvantage}>
          <LemanaProLogoSimpleIcon size="xxl" strokeWidth={1} />
          <div className={easyRefundAdvantageText}>
            <Typography variant="m" size="body_accent" color="text-primary">
              {t('product-returns.modal.part3')}
            </Typography>
            <Typography variant="s" size="body_long" color="text-primary">
              {t('product-returns.modal.part4', { brand: STORE_BRAND_NAME })}
            </Typography>
          </div>
        </div>
        <div className={easyRefundAdvantage}>
          <CheckSquareOffsetIcon size="xxl" strokeWidth={1} />
          <div className={easyRefundAdvantageText}>
            <Typography variant="m" size="body_accent" color="text-primary">
              {t('product-returns.modal.part5')}
            </Typography>
            <Typography variant="s" size="body_long" color="text-primary">
              {t('product-returns.modal.part6')}
            </Typography>
          </div>
        </div>
        <div className={easyRefundAdvantage}>
          <ArrowBendDoubleUpLeftIcon size="xxl" strokeWidth={1} />
          <div className={easyRefundAdvantageText}>
            <Typography variant="m" size="body_accent" color="text-primary">
              {t('product-returns.modal.part7')}
            </Typography>
            <Typography variant="s" size="body_long" color="text-primary">
              {t('product-returns.modal.part8')}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
